import { z } from 'zod';
import { ArtifactTypeSchema, JsonValueSchema } from '@terra/shared-schemas-ai';

export const CreateArtifactBodySchema = z.object({
  type: ArtifactTypeSchema,
  threadId: z.string(),
  executionId: z.string().optional(),
  traceId: z.string().optional(),
  runtimeId: z.string().optional(),
  toolName: z.string().optional(),
  toolCallId: z.string().optional(),
  actionFileName: z.string().optional(),
  actionContent: z.string().optional(),
  resultFileName: z.string().optional(),
  resultContent: z.string().optional(),
  startedAt: z.coerce.date().optional(),
  completedAt: z.coerce.date().optional(),
  durationMs: z.int().optional(),
  metadata: JsonValueSchema.nullable().optional(),
});

export const UpdateArtifactBodySchema = z.object({
  resultFileName: z.string().optional(),
  resultContent: z.string().optional(),
  completedAt: z.coerce.date().optional(),
  durationMs: z.int().optional(),
  metadata: JsonValueSchema.nullable().optional(),
});

export const ArtifactFilterQuerySchema = z.object({
  executionId: z.string().optional(),
  traceId: z.string().optional(),
  threadId: z.string().optional(),
  toolCallId: z.string().optional(),
  type: ArtifactTypeSchema.optional(),
});
